import { Injectable } from '@angular/core';
import { PlacesApiService } from '@fleet-beat/api';
import { BaseDataSourceServiceV2, PageableListV2Dto, SelectOption, SnackbarService, TimeZones } from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService } from '@fleet-beat/shared';
import { Observable, delay, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimezoneAutocompleteStorageService extends BaseDataSourceServiceV2<
  SelectOption,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private placesApiService: PlacesApiService,
  ) {
    super(snackbarService);
  }

  protected override getData(data: DataAutocompleteStorageParams<object>): Observable<PageableListV2Dto<SelectOption>> {
    if (!data.params.input) {
      return of({ data: [], offset: undefined, limit: undefined, total: 0 });
    }
    return of({
      data: this.getSearchResult(data.params.input),
      limit: 5,
      offset: 0,
      total: 10,
    }).pipe(delay(500));
  }

  private getSearchResult(search: string): SelectOption[] {
    const matchingOptions: SelectOption[] = [];
    for (const option of TimeZones) {
      if (option.label.toLowerCase().includes(search.toLowerCase())) {
        matchingOptions.push(option);
      }
      if (matchingOptions.length === 10) {
        break;
      }
    }
    return matchingOptions;
  }
}
